import React from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import StaticSidebarList from 'components/static/sidebar-list';

import { mainLinks, userLinks, companyLinks } from './sidebar.data';

import './sidebar.scss';

const StaticSidebar: React.FC = () => {
    const currentUrl: string = useSelector((state: { currentUrl: string; }) => state.currentUrl);

    return (
        <div className="static-sidebar">
            <StaticSidebarList links={mainLinks} currentUrl={currentUrl}/>
            <div className="static-sidebar__header">
                Dla użytkowników
            </div>
            <StaticSidebarList links={userLinks} currentUrl={currentUrl}/>
            <div className="static-sidebar__header">
                Dla firm
            </div>
            <StaticSidebarList links={companyLinks} currentUrl={currentUrl}/>
        </div>
    );
};

export default StaticSidebar;
